import tw from 'tailwind-styled-components'
import {cn} from '@containers/html-utils'

export const TwTableHeadCell = tw.div<{$active: boolean; $disabled: boolean}>`
  group/headCell
  px-8
  py-8
  flex
  items-center
  ${({$active}) => ($active ? 'text-action-default' : 'text-placeholder')}
  ${({$disabled}) =>
    !$disabled ? 'cursor-pointer hover:text-action-default' : 'cursor-default'}

  uppercase
  text-10
  font-semibold
  relative
`

export const TwTableHeadSort = tw.div`
  flex
  items-center
  justify-center
`

export const TwTableRowInner = tw.div<{
  $draggable: boolean
  $hoverable: boolean
  $managedHover?: boolean
  $hovered?: boolean
  $subRowLevel?: number
  $isDragging?: boolean
  $isDropZone?: boolean
  $noBorders?: boolean
  $highlighted: boolean
}>`
  group/row
  relative
  w-full
  h-full

  bg-background-primary
  items-stretch

  border-0
  border-solid
  border-line-base

  ${p => (p.$draggable ? 'cursor-pointer' : '')}
  ${p => {
    if (p.$noBorders) {
      return 'border-0'
    }
    return p.$subRowLevel ? 'border-t-1' : 'border-b-1'
  }}
  ${p => (p.$subRowLevel ? 'ml-[24px]' : '')}
  ${p =>
    cn(
      p.$managedHover && p.$hovered && '!bg-background-hover',
      !p.$managedHover &&
        (p.$draggable || p.$hoverable) &&
        !p.$isDragging &&
        cn('hover:bg-background-hover', 'group-hover/row:bg-background-hover')
    )}
  ${p => (p.$highlighted ? '!bg-background-hover' : '')}
`

export const TwColumnsWrapper = tw.div<{$isDragging?: boolean}>`
  flex
  h-full
  ${p => (p.$isDragging ? 'pointer-events-none' : '')}
`

export const TwDragIconWrapper = tw.div`
  flex
  absolute
  left-4
  top-1/2
  transform
  -translate-y-1/2
  hidden
  group-hover/row:block
`

export const TwOverlay = tw.div`
  absolute
  top-0
  bottom-0
  left-0
  right-0
  bg-background-hover
  z-20
  pointer-events-none
  rounded-8
`

export const TwDropPlaceholder = tw.div<{$isNew?: boolean; visible: boolean}>`
  z-20
  left-0
  right-0
  h-[3px]
  absolute
  bg-action-default
  pointer-events-none
  transition-opacity
  duration-100
  opacity-1
  ${props =>
    props.$isNew
      ? `
    w-full
    left-auto
    right-auto
    !h-[1px]
    before:content-['']
    before:w-4
    before:h-4
    before:bg-action-default
    before:absolute
    before:left-[-2px]
    before:top-1/2
    before:-translate-y-1/2
    before:rounded-full
  `
      : ''}
  ${props => (props.visible ? '' : 'opacity-0')}
`
